import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42k2KPQoAEABGv/xEVotIWUgWd3AAm839z4GkvO29HnAhwpRWs+uMwm7Xp+GDJanaCGpyirjdv2EBbIwDKXUca+0AAAAASUVORK5CYII="};
